module.exports = __webpack_public_path__ + "img/TRASH.bf97f093.svg";